export default __webpack_public_path__ + "favicon-120-275edb873a8456a07fbe72b6e8a1b002.bundle.png";